import { Box, Text } from '@stenajs-webui/core';
import { Spinner, stenaHistory } from '@stenajs-webui/elements';
import type { FC } from 'react';
import type { BasicBooking } from '../../../../common/graphql/fragments/gql/BasicBooking';
import { useBookingHistory } from '../../../../common/graphql/useBookingHistory';
import { PopoverBody } from '../../../../common-ui/popover/PopoverBody';
import { PopoverTitle } from '../../../../common-ui/popover/PopoverTitle';
import { transformHistoryRows } from '../utils/historyUtil';
import { HistoryTable } from './HistoryTable';

export interface HistoryProps {
  bookingNo: BasicBooking['bookingNo'];
  onClose: () => void;
}

export const HistoryPanel: FC<HistoryProps> = ({ bookingNo, onClose }) => {
  const [history, loading] = useBookingHistory(bookingNo);

  return (
    <Box minWidth={320}>
      <PopoverTitle text={'History'} icon={stenaHistory} onClose={onClose} />
      <PopoverBody>
        {history ? (
          <HistoryTable rows={transformHistoryRows(history)} />
        ) : loading ? (
          <Box alignItems={'center'}>
            <Spinner size={'small'} />
          </Box>
        ) : (
          <Text>No history found for this booking.</Text>
        )}
      </PopoverBody>
    </Box>
  );
};
